import { useCreate, useGetIdentity } from "ra-core";

import type { MessageTemplate } from "../types";
import { MessageTemplateDialog } from "./MessageTemplateDialog";

type MessageTemplateCreateProps = {
  open: boolean;
  onClose(): void;
};

export function MessageTemplateCreate({
  open,
  onClose,
}: MessageTemplateCreateProps) {
  const [create] = useCreate<MessageTemplate>();
  const { identity } = useGetIdentity();

  const handleCreate = async (
    data: Pick<MessageTemplate, "name" | "body" | "channel">,
  ) => {
    await create("messageTemplates", {
      data: {
        ...data,
        sales_id: identity?.id,
      },
    });
  };

  return (
    <MessageTemplateDialog
      open={open}
      title="Create template"
      onClose={onClose}
      onSubmit={handleCreate}
    />
  );
}
